module.exports = __webpack_public_path__ + "static/media/Email.3334384f.svg";